<template>
<div class="chapter">
<div class="inner_page">
<div class="forward" id="sec-1">
<h1 class="chapter" id="pz1-1" style="text-align: center;">
					Praise for <br/><i>Finding Their Voices</i> </h1>
<p id="pz1-2">
					“This historic collection provides a breathtaking documentation of the first wave
					of preaching which spans an entire generation in Churches of Christ. These preachers
					are typically courageous and gifted and together provide an exciting harbinger of
					the next millennium of sermons from the ‘other half ’ of the church. That their voices
					had been silenced is a tragedy. That these trailblazers have forged new possibilities
					and set standards of preaching excellence is exhilarating.” </p>
<p class="pa" id="pz1-3" style="margin-top: 0em;">
<b>—David Fleer,</b> professor of homiletics, special assistant to the president, and director
						of the Thomas H. Olbricht Christian Scholars’ Conference, Lipscomb University </p>
<p id="pz1-4">
					“D’Esta Love has served as mentor and guide for many Christians who received God’s
					call to ministry but who faced daunting barriers because of gender. Love has assembled
					a remarkable group of leaders—herself included—who share stories of pain and hope
					along with transformative preaching. A landmark book, <i>Finding Their Voices</i> will serve
					to move Christ’s church closer to a true reflection of God’s eternal kingdom where
					distinctions created by sin are overcome by the blood of Christ.” </p>
<p class="pa" id="pz1-5" style="margin-top: 0em;">
<b>—Douglas A. Foster,</b> professor of church history and director of the Center for Restoration
						Studies, Abilene Christian University </p>
<p id="pz1-6">
					“I was moved to tears many times as this collection of sermons compelled me to pay
					closer heed to the voices of Christian women. Even—perhaps especially—those who have
					never before heard a woman preach will, I predict, be blessed by the keen and skillful
					testimony of these witnesses to the glory and gospel of Jesus Christ. We owe a great
					debt of thankfulness to D’Esta Love, Pepperdine’s first chaplain and a true Phoebe
					among us, for ensuring that these voices will be heard.” </p>
<p class="pa" id="pz1-7" style="margin-top: 0em;">
<b>—Ken Durham,</b> Batsell Barrett Baxter Chair of Preaching, College of Bible and Ministry,
						Lipscomb University </p>
<p id="pz1-8">
					“This remarkable volume fittingly echoes the conviction of the Apostle Paul: ‘We
					also believe, and so we speak’ (2 Cor. 4:13). After generations of enforced silence,
					the other half of the church accepts the belated invitation to speak aloud; and when
					these women speak, they do so clearly, convincingly, compassionately, and wisely.
					<i>Finding Their Voices</i> surely signals a historic hinge moment in the history of the
					Churches of Christ.” </p>
<p class="pa" id="pz1-9" style="margin-top: 0em;">
<b>—Darryl Tippens,</b> University Distinguished Scholar, Abilene Christian University,
						co-editor, <i>Shadow &amp; Light: Literature and the Life of Faith</i> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?16e79d6a